// extracted by mini-css-extract-plugin
export default {"root":"IconWhatsApp_root__5DtY5"};